export const getMaxDateMessage = fieldName => `${fieldName} cannot be a future date`;

export const getPastDateMessage = fieldName => `${fieldName} cannot be a past date`;

export const getTenYearsMinDateMessage = fieldName => `${fieldName} should not be older than 10 years from today`;

export const getTenYearsMaxDateMessage = fieldName => `${fieldName} should not be more than 10 years`;

export const getGreaterThanMessage = fieldName => `${fieldName} must be greater than `;

export const getRequiredNotTextInputMessage = fieldName => `${fieldName} is not filled`;

export const getRequiredMessage = fieldName => `${fieldName} is blank`;

export const getInvalidMessage = fieldName => `${fieldName} is invalid`;

export const getMinDateMessage = fieldName => `${fieldName} should not be less than 01/01/1900`;

export const getROInvalidMessage = "Only numbers without spaces are allowed";

export const getNotTrimmedMessage = fieldName => `${fieldName} should not have trailing spaces`;
